var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrilliantEffort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 119,
    viewBox: "0 0 154 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.485 25.1641L104.922 28.751V40.7529L143.132 37.9305C145.64 37.7472 147.704 36.3805 148.856 34.1445L153.485 25.1641Z",
    fill: "url(#paint0_linear_308_8028)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.922 39.6399L143.734 36.7703C146.243 36.587 148.306 35.2203 149.458 32.9844L148.856 34.1469C147.704 36.3828 145.64 37.7495 143.132 37.9328L104.922 40.7552V39.6346V39.6399Z",
    fill: "url(#paint1_linear_308_8028)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.132 37.9336L104.922 40.756V52.7579L132.785 50.7C135.293 50.5167 137.356 49.15 138.508 46.9141L143.137 37.9336H143.132Z",
    fill: "url(#paint2_linear_308_8028)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.925 51.641L133.385 49.5359C135.893 49.3527 137.957 47.986 139.109 45.75L138.506 46.9125C137.354 49.1484 135.291 50.5152 132.783 50.6984L104.92 52.7563V51.6357L104.925 51.641Z",
    fill: "url(#paint3_linear_308_8028)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.783 50.6992L104.92 52.7571V64.759L122.431 63.4656C124.939 63.2824 127.002 61.9157 128.154 59.6797L132.783 50.6992Z",
    fill: "url(#paint4_linear_308_8028)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.925 63.6382L123.033 62.2977C125.541 62.1144 127.604 60.7477 128.756 58.5117L128.154 59.6742C127.002 61.9102 124.939 63.2769 122.431 63.4601L104.92 64.7535V63.6329L104.925 63.6382Z",
    fill: "url(#paint5_linear_308_8028)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.462891 25.1641L49.0256 28.751V40.7529L10.8153 37.9305C8.30707 37.7472 6.24391 36.3805 5.0919 34.1445L0.462891 25.1641Z",
    fill: "url(#paint6_linear_308_8028)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.028 39.6399L10.2156 36.7703C7.70736 36.587 5.6442 35.2203 4.49219 32.9844L5.09438 34.1469C6.24639 36.3828 8.30955 37.7495 10.8178 37.9328L49.028 40.7552V39.6346V39.6399Z",
    fill: "url(#paint7_linear_308_8028)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8177 37.9336L49.028 40.756V52.7579L21.1649 50.7C18.6567 50.5167 16.5935 49.15 15.4415 46.9141L10.8125 37.9336H10.8177Z",
    fill: "url(#paint8_linear_308_8028)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0272 51.641L20.5672 49.5359C18.0589 49.3527 15.9958 47.986 14.8438 45.75L15.4459 46.9125C16.598 49.1484 18.6611 50.5152 21.1694 50.6984L49.0324 52.7563V51.6357L49.0272 51.641Z",
    fill: "url(#paint9_linear_308_8028)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1641 50.6992L49.0271 52.7571V64.759L31.5165 63.4656C29.0082 63.2824 26.9451 61.9157 25.7931 59.6797L21.1641 50.6992Z",
    fill: "url(#paint10_linear_308_8028)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0263 63.6382L30.9187 62.2977C28.4105 62.1144 26.3473 60.7477 25.1953 58.5117L25.7975 59.6742C26.9495 61.9102 29.0127 63.2769 31.5209 63.4601L49.0316 64.7535V63.6329L49.0263 63.6382Z",
    fill: "url(#paint11_linear_308_8028)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6227 95.1733C68.6528 92.4347 60.5206 89.1253 54.3574 83.1871C44.9004 74.0758 42.6016 60.7752 42.6016 48.1921V21.4287L43.2928 21.1616C53.9699 17.0301 65.4743 14.1448 76.8531 12.8933L76.9735 12.8828L77.0939 12.8933C88.4727 14.15 99.9771 17.0301 110.654 21.1616L111.345 21.4287V48.1921C111.345 60.7805 109.047 74.0758 99.5897 83.1871C93.4264 89.1253 85.2994 92.4347 77.3243 95.1733L76.9735 95.2938L76.6227 95.1733Z",
    fill: "url(#paint12_linear_308_8028)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1139 18.4082C50.3148 13.2817 63.8981 9.73141 76.9735 8.35946V2.76172C61.5155 4.3117 45.6334 8.83074 32.5371 14.7636L38.1087 18.4134L38.1139 18.4082Z",
    fill: "url(#paint13_linear_308_8028)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9728 8.35938C63.8975 9.73132 50.3089 13.2816 38.1133 18.4081L43.6848 22.1678C54.2886 18.0625 65.8245 15.1877 76.9728 13.9624V8.35938Z",
    fill: "url(#paint14_linear_308_8028)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1126 48.1924V18.4076L32.541 14.7578V48.1924C32.541 90.4243 57.2936 99.3681 76.9774 105.914V100.038C67.6984 96.9122 58.4299 93.3462 51.2456 86.4236C40.8512 76.4063 38.1178 62.1109 38.1178 48.1924H38.1126Z",
    fill: "url(#paint15_linear_308_8028)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1146 18.4062V48.1911C38.1146 62.1095 40.848 76.405 51.2423 86.4223C58.4215 93.3448 67.6952 96.9109 76.9742 100.037V94.1512C69.1195 91.4492 61.1235 88.2027 55.1068 82.4112C45.8907 73.5302 43.6809 60.481 43.6809 48.1911V22.166L38.1094 18.4062H38.1146Z",
    fill: "url(#paint16_linear_308_8028)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.838 18.4082C103.637 13.2817 90.0539 9.73141 76.9785 8.35946V2.76172C92.4365 4.3117 108.319 8.83074 121.415 14.7636L115.843 18.4134L115.838 18.4082Z",
    fill: "url(#paint17_linear_308_8028)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9727 8.35938C90.048 9.73132 103.637 13.2816 115.832 18.4081L110.261 22.1678C99.6569 18.0625 88.1158 15.1877 76.9727 13.9624V8.35938Z",
    fill: "url(#paint18_linear_308_8028)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.837 48.1924V18.4076L121.409 14.7578V48.1924C121.409 90.4243 96.6564 99.3681 76.9727 105.914V100.038C86.2516 96.9122 95.5201 93.3462 102.704 86.4236C113.099 76.4063 115.832 62.1109 115.832 48.1924H115.837Z",
    fill: "url(#paint19_linear_308_8028)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.838 18.4062V48.1911C115.838 62.1095 113.105 76.405 102.71 86.4223C95.526 93.3448 86.2575 96.9109 76.9785 100.037V94.1512C84.8332 91.4492 92.8292 88.2027 98.8459 82.4112C108.062 73.5302 110.272 60.481 110.272 48.1911V22.166L115.843 18.4062H115.838Z",
    fill: "url(#paint20_linear_308_8028)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6836 22.1664C54.146 18.3176 68.4676 16.3069 76.9716 15.9717C85.4756 16.3069 99.7972 18.3124 110.26 22.1664C99.6558 18.0611 88.1147 15.1863 76.9716 13.9609C65.8232 15.1863 54.2874 18.0611 43.6836 22.1664Z",
    fill: "url(#paint21_radial_308_8028)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0628 78.2235C85.1967 90.8642 68.7438 90.8642 54.8777 78.2235C48.0442 71.9974 45.0385 63.6505 43.9336 55.0156C44.7295 65.1376 47.5834 75.1602 55.1029 82.4074C61.1143 88.1989 69.1104 91.4507 76.9703 94.1475C84.8249 91.4455 92.8209 88.1989 98.8376 82.4074C106.362 75.1602 109.211 65.1324 110.007 55.0156C108.902 63.6453 105.896 71.9921 99.0628 78.2183V78.2235Z",
    fill: "url(#paint22_radial_308_8028)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1332 58.8418C63.0368 58.8418 51.1448 53.265 47.4322 45.6408C45.7408 42.169 45.7042 24.606 48.0449 23.2393C53.3389 20.1498 69.2995 17.4688 77.1332 17.4688C84.9669 17.4688 100.928 20.1498 106.222 23.2393C108.562 24.606 108.526 42.1742 106.834 45.6408C103.122 53.265 91.2297 58.8418 77.1332 58.8418Z",
    fill: "url(#paint23_radial_308_8028)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9745 48.3425C65.8785 48.3425 56.5157 44.6351 53.5938 39.561C52.2637 37.2517 52.2323 23.9407 54.0755 23.0348C58.2437 20.9769 70.0938 18.7305 76.9745 18.7305C83.8551 18.7305 95.7052 20.9769 99.8734 23.0348C101.717 23.946 101.685 37.257 100.355 39.561C97.4332 44.6299 88.0705 48.3425 76.9745 48.3425Z",
    fill: "url(#paint24_radial_308_8028)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2999 46.448C37.2999 55.0096 37.8288 58.3242 40.049 66.1213C38.6195 60.3246 38.1063 54.2241 38.1063 48.1917V18.4069C49.7103 13.5318 62.5709 10.081 75.0494 8.57812C67.6136 9.41595 61.0681 10.5104 54.6116 12.1441C54.266 11.72 53.6899 11.5158 53.1349 11.6781C52.6008 11.8352 52.229 12.2803 52.1452 12.7935C50.7261 13.1862 49.3018 13.6051 47.8723 14.0554C47.3382 13.4951 46.5108 13.2595 45.7306 13.5266C44.9608 13.7884 44.4476 14.4639 44.3534 15.2179C42.2483 15.9458 40.1066 16.747 37.9073 17.6214L33.3359 15.2808L37.2999 18.5849V46.448Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M48.6605 25.2039C55.4683 25.2039 60.9871 19.6851 60.9871 12.8773C60.9871 6.06957 55.4683 0.550781 48.6605 0.550781C41.8528 0.550781 36.334 6.06957 36.334 12.8773C36.334 19.6851 41.8528 25.2039 48.6605 25.2039Z",
    fill: "url(#paint25_radial_308_8028)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4492 102.372L42.7196 108.719V102.372H21.4492Z",
    fill: "#CD74D7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.488 102.372L111.223 108.719V102.372H132.488Z",
    fill: "#CD74D7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7205 108.72L26.3828 114.559V103.85L42.7205 108.72Z",
    fill: "#E195E9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.223 108.72L127.555 114.559V103.85L111.223 108.72Z",
    fill: "#E195E9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5516 111.635V118.27L26.3828 114.557L34.5516 111.635Z",
    fill: "#D17FDA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.389 111.635V118.27L127.552 114.557L119.389 111.635Z",
    fill: "#D17FDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_308_8028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0918 76.4285H137.231L132.676 102.375H21.6423L17.0918 76.4285Z",
    fill: "#5F488A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_308_8028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1408 91.8354C37.6928 91.8354 37.2408 91.8034 36.7848 91.7394C36.3288 91.6834 35.9488 91.6074 35.6448 91.5114C35.6768 91.1674 35.7008 90.6594 35.7168 89.9874C35.7408 89.3154 35.7528 88.6634 35.7528 88.0314C35.7528 86.7194 35.6888 85.9194 35.5608 85.6314C35.8648 85.5354 36.2488 85.4594 36.7128 85.4034C37.1768 85.3394 37.6368 85.3074 38.0928 85.3074C38.8928 85.3074 39.5048 85.4554 39.9288 85.7514C40.3608 86.0394 40.5768 86.4554 40.5768 86.9994C40.5768 87.2794 40.4888 87.5354 40.3128 87.7674C40.1448 87.9994 39.9048 88.1914 39.5928 88.3434C39.9928 88.5034 40.3048 88.7234 40.5288 89.0034C40.7608 89.2834 40.8768 89.6034 40.8768 89.9634C40.8768 90.5634 40.6408 91.0274 40.1688 91.3554C39.6968 91.6754 39.0208 91.8354 38.1408 91.8354ZM37.1088 88.2114C37.4128 88.1394 37.7528 88.1034 38.1288 88.1034L38.4768 88.1154C38.6768 87.9874 38.8328 87.8394 38.9448 87.6714C39.0568 87.4954 39.1128 87.3154 39.1128 87.1314C39.1128 86.5394 38.7288 86.2434 37.9608 86.2434C37.6888 86.2434 37.4248 86.2794 37.1688 86.3514C37.1368 87.0474 37.1168 87.6674 37.1088 88.2114ZM38.0088 91.1394C38.9448 91.1394 39.4128 90.7474 39.4128 89.9634C39.4128 89.6914 39.3288 89.4514 39.1608 89.2434C38.9928 89.0354 38.7528 88.8714 38.4408 88.7514C38.1288 88.7514 37.6808 88.8514 37.0968 89.0514C37.0968 89.8434 37.1168 90.4914 37.1568 90.9954C37.4208 91.0914 37.7048 91.1394 38.0088 91.1394ZM42.8601 91.7634C42.6041 91.7634 42.3121 91.7394 41.9841 91.6914C42.0241 91.2994 42.0561 90.7594 42.0801 90.0714C42.1041 89.3754 42.1161 88.7354 42.1161 88.1514C42.1161 86.7834 42.0521 85.9434 41.9241 85.6314C42.1801 85.5354 42.5321 85.4594 42.9801 85.4034C43.4281 85.3394 43.8761 85.3074 44.3241 85.3074C45.1641 85.3074 45.8081 85.4914 46.2561 85.8594C46.7121 86.2194 46.9401 86.7394 46.9401 87.4194C46.9401 87.8114 46.8321 88.1634 46.6161 88.4754C46.4081 88.7794 46.1161 89.0234 45.7401 89.2074C46.3641 90.4314 46.8601 91.1994 47.2281 91.5114C46.9641 91.6074 46.6921 91.6714 46.4121 91.7034C46.1401 91.7434 45.8281 91.7634 45.4761 91.7634C45.3161 91.3394 44.9481 90.5914 44.3721 89.5194L44.1801 89.5314C44.0201 89.5314 43.7801 89.5114 43.4601 89.4714C43.4681 90.5994 43.5321 91.3394 43.6521 91.6914C43.3881 91.7394 43.1241 91.7634 42.8601 91.7634ZM44.6481 88.7634C44.8961 88.6354 45.0961 88.4634 45.2481 88.2474C45.4001 88.0314 45.4761 87.7874 45.4761 87.5154C45.4761 86.6674 45.0081 86.2434 44.0721 86.2434C43.8641 86.2434 43.6841 86.2634 43.5321 86.3034C43.5001 86.9114 43.4761 87.6474 43.4601 88.5114C43.9881 88.6794 44.3841 88.7634 44.6481 88.7634ZM49.0125 91.7634C48.7565 91.7634 48.4645 91.7394 48.1365 91.6914C48.2245 90.4594 48.2685 89.2794 48.2685 88.1514C48.2685 86.6794 48.2045 85.7514 48.0765 85.3674C48.3405 85.3194 48.6205 85.2954 48.9165 85.2954C49.1565 85.2954 49.4325 85.3194 49.7445 85.3674C49.7045 85.7834 49.6725 86.3394 49.6485 87.0354C49.6245 87.7234 49.6125 88.3674 49.6125 88.9674C49.6125 90.4314 49.6765 91.3394 49.8045 91.6914C49.5405 91.7394 49.2765 91.7634 49.0125 91.7634ZM51.1247 91.7274C51.2127 90.5274 51.2567 89.3354 51.2567 88.1514C51.2567 86.6314 51.1927 85.7034 51.0647 85.3674C51.3287 85.3194 51.6007 85.2954 51.8807 85.2954C52.1287 85.2954 52.4127 85.3194 52.7327 85.3674C52.6927 85.7834 52.6607 86.3394 52.6367 87.0354C52.6127 87.7234 52.6007 88.3674 52.6007 88.9674C52.6007 89.6474 52.6127 90.1794 52.6367 90.5634C52.9807 90.6274 53.3487 90.6594 53.7407 90.6594C54.0287 90.6594 54.3207 90.6314 54.6167 90.5754C54.9207 90.5114 55.1767 90.4314 55.3847 90.3354C55.3847 90.5914 55.3607 90.8634 55.3127 91.1514C55.2647 91.4314 55.2047 91.6234 55.1327 91.7274C54.6767 91.6714 54.0327 91.6434 53.2007 91.6434C52.2727 91.6434 51.5807 91.6714 51.1247 91.7274ZM56.1638 91.7274C56.2518 90.5274 56.2958 89.3354 56.2958 88.1514C56.2958 86.6314 56.2318 85.7034 56.1038 85.3674C56.3678 85.3194 56.6398 85.2954 56.9198 85.2954C57.1678 85.2954 57.4518 85.3194 57.7718 85.3674C57.7318 85.7834 57.6998 86.3394 57.6758 87.0354C57.6518 87.7234 57.6398 88.3674 57.6398 88.9674C57.6398 89.6474 57.6518 90.1794 57.6758 90.5634C58.0198 90.6274 58.3878 90.6594 58.7798 90.6594C59.0678 90.6594 59.3598 90.6314 59.6558 90.5754C59.9598 90.5114 60.2158 90.4314 60.4238 90.3354C60.4238 90.5914 60.3998 90.8634 60.3518 91.1514C60.3038 91.4314 60.2438 91.6234 60.1718 91.7274C59.7158 91.6714 59.0718 91.6434 58.2398 91.6434C57.3118 91.6434 56.6198 91.6714 56.1638 91.7274ZM62.0789 91.7634C61.8229 91.7634 61.5309 91.7394 61.2029 91.6914C61.2909 90.4594 61.3349 89.2794 61.3349 88.1514C61.3349 86.6794 61.2709 85.7514 61.1429 85.3674C61.4069 85.3194 61.6869 85.2954 61.9829 85.2954C62.2229 85.2954 62.4989 85.3194 62.8109 85.3674C62.7709 85.7834 62.7389 86.3394 62.7149 87.0354C62.6909 87.7234 62.6789 88.3674 62.6789 88.9674C62.6789 90.4314 62.7429 91.3394 62.8709 91.6914C62.6069 91.7394 62.3429 91.7634 62.0789 91.7634ZM68.9912 91.7514C68.7432 91.7514 68.4752 91.7234 68.1872 91.6674C67.9392 90.9554 67.7632 90.4594 67.6592 90.1794C67.2352 90.1554 66.7712 90.1434 66.2672 90.1434C65.7232 90.1434 65.3392 90.1594 65.1152 90.1914C64.9792 90.5514 64.8032 91.0434 64.5872 91.6674C64.4112 91.7154 64.2512 91.7394 64.1072 91.7394C63.9232 91.7394 63.7352 91.7154 63.5432 91.6674C63.7672 91.2674 64.1632 90.3234 64.7312 88.8354C65.2992 87.3474 65.7232 86.1834 66.0032 85.3434C66.2832 85.3034 66.5192 85.2834 66.7112 85.2834C66.9112 85.2834 67.1312 85.3034 67.3712 85.3434C67.6512 86.1834 68.0752 87.3474 68.6432 88.8354C69.2112 90.3234 69.6072 91.2674 69.8312 91.6674C69.5752 91.7234 69.2952 91.7514 68.9912 91.7514ZM66.7232 89.3154C66.8912 89.3154 67.0952 89.3074 67.3352 89.2914C66.9592 88.2514 66.6432 87.4354 66.3872 86.8434C66.1312 87.4674 65.8192 88.2794 65.4512 89.2794C65.8432 89.3034 66.2672 89.3154 66.7232 89.3154ZM71.0819 91.7634C70.9219 91.7634 70.7259 91.7394 70.4939 91.6914C70.5579 90.8594 70.5899 89.6794 70.5899 88.1514C70.5899 86.6714 70.5459 85.7434 70.4579 85.3674C70.6819 85.3194 70.9419 85.2954 71.2379 85.2954C71.4699 85.2954 71.7659 85.3194 72.1259 85.3674C72.3819 85.8714 72.7739 86.5874 73.3019 87.5154C73.8379 88.4434 74.3379 89.2914 74.8019 90.0594C74.8179 89.2114 74.8259 88.5554 74.8259 88.0914C74.8259 86.6034 74.7819 85.6954 74.6939 85.3674C74.8619 85.3194 75.0299 85.2954 75.1979 85.2954C75.3739 85.2954 75.5739 85.3194 75.7979 85.3674C75.7339 86.4074 75.7019 87.5874 75.7019 88.9074C75.7019 90.3714 75.7459 91.2994 75.8339 91.6914C75.6179 91.7394 75.3619 91.7634 75.0659 91.7634C74.7939 91.7634 74.4899 91.7394 74.1539 91.6914C73.8979 91.2034 73.5059 90.4994 72.9779 89.5794C72.4579 88.6514 71.9619 87.7914 71.4899 86.9994C71.4739 87.8474 71.4659 88.5034 71.4659 88.9674C71.4659 90.4074 71.5099 91.3154 71.5979 91.6914C71.4299 91.7394 71.2579 91.7634 71.0819 91.7634ZM79.1455 91.7634C78.9135 91.7634 78.6295 91.7394 78.2935 91.6914C78.3335 91.2754 78.3655 90.7234 78.3895 90.0354C78.4135 89.3394 78.4255 88.6914 78.4255 88.0914C78.4255 87.5794 78.4095 87.0594 78.3775 86.5314C77.3935 86.5394 76.7815 86.5914 76.5415 86.6874C76.5015 86.4074 76.4815 86.1714 76.4815 85.9794C76.4815 85.8194 76.5015 85.6194 76.5415 85.3794C76.8695 85.4114 77.3095 85.4394 77.8615 85.4634C78.4215 85.4794 78.9495 85.4874 79.4455 85.4874C80.6375 85.4874 81.3735 85.4354 81.6535 85.3314C81.6935 85.5874 81.7135 85.7994 81.7135 85.9674C81.7135 86.1754 81.6935 86.3994 81.6535 86.6394C81.1895 86.5994 80.5815 86.5674 79.8295 86.5434C79.7895 87.3674 79.7695 88.1754 79.7695 88.9674C79.7695 90.4314 79.8335 91.3394 79.9615 91.6914C79.7455 91.7394 79.4735 91.7634 79.1455 91.7634ZM85.3318 91.7274C85.4198 90.5354 85.4638 89.3234 85.4638 88.0914C85.4638 87.3554 85.4478 86.7914 85.4158 86.3994C85.3918 85.9994 85.3438 85.6554 85.2718 85.3674C85.7118 85.4234 86.3918 85.4514 87.3118 85.4514C88.4078 85.4514 89.2598 85.4234 89.8678 85.3674C89.8678 85.6314 89.8438 85.9154 89.7958 86.2194C89.7478 86.5154 89.6878 86.7154 89.6158 86.8194C89.4158 86.7154 89.1558 86.6354 88.8358 86.5794C88.5158 86.5234 88.1878 86.4954 87.8518 86.4954C87.4918 86.4954 87.1638 86.5194 86.8678 86.5674C86.8358 87.1914 86.8198 87.6954 86.8198 88.0794C87.1558 88.0954 87.4158 88.1034 87.5998 88.1034C87.9998 88.1034 88.3078 88.0954 88.5238 88.0794C88.7398 88.0554 88.9798 88.0194 89.2438 87.9714C89.2758 88.1794 89.2918 88.3554 89.2918 88.4994C89.2918 88.6194 89.2758 88.7994 89.2438 89.0394C88.1878 88.9754 87.3758 88.9474 86.8078 88.9554C86.8078 89.5874 86.8198 90.1034 86.8438 90.5034C87.1798 90.5674 87.5358 90.5994 87.9118 90.5994C88.2798 90.5994 88.6478 90.5714 89.0158 90.5154C89.3838 90.4594 89.6838 90.3794 89.9158 90.2754C89.9158 90.5394 89.8918 90.8194 89.8438 91.1154C89.7958 91.4114 89.7358 91.6154 89.6638 91.7274C89.1278 91.6714 88.3638 91.6434 87.3718 91.6434C86.4598 91.6434 85.7798 91.6714 85.3318 91.7274ZM91.8796 91.7634C91.6236 91.7634 91.3316 91.7394 91.0036 91.6914C91.0436 91.3154 91.0756 90.8074 91.0996 90.1674C91.1236 89.5274 91.1356 88.9354 91.1356 88.3914C91.1356 87.5754 91.1196 86.9474 91.0876 86.5074C91.0636 86.0674 91.0156 85.6874 90.9436 85.3674C91.4236 85.4234 92.1036 85.4514 92.9836 85.4514C94.0236 85.4514 94.7956 85.4234 95.2996 85.3674C95.2996 85.6394 95.2756 85.9274 95.2276 86.2314C95.1796 86.5274 95.1196 86.7234 95.0476 86.8194C94.8796 86.7154 94.6596 86.6354 94.3876 86.5794C94.1156 86.5234 93.8276 86.4954 93.5236 86.4954C93.1556 86.4954 92.8156 86.5194 92.5036 86.5674C92.4796 87.2874 92.4676 87.7914 92.4676 88.0794C92.7556 88.0954 92.9836 88.1034 93.1516 88.1034C93.5116 88.1034 93.7916 88.0954 93.9916 88.0794C94.1996 88.0554 94.4276 88.0194 94.6756 87.9714C94.7076 88.1554 94.7236 88.3314 94.7236 88.4994C94.7236 88.6674 94.7076 88.8474 94.6756 89.0394C93.7316 88.9754 92.9996 88.9474 92.4796 88.9554C92.4796 90.4434 92.5436 91.3554 92.6716 91.6914C92.4076 91.7394 92.1436 91.7634 91.8796 91.7634ZM97.0828 91.7634C96.8268 91.7634 96.5348 91.7394 96.2068 91.6914C96.2468 91.3154 96.2788 90.8074 96.3028 90.1674C96.3268 89.5274 96.3388 88.9354 96.3388 88.3914C96.3388 87.5754 96.3228 86.9474 96.2908 86.5074C96.2668 86.0674 96.2188 85.6874 96.1468 85.3674C96.6268 85.4234 97.3068 85.4514 98.1868 85.4514C99.2268 85.4514 99.9988 85.4234 100.503 85.3674C100.503 85.6394 100.479 85.9274 100.431 86.2314C100.383 86.5274 100.323 86.7234 100.251 86.8194C100.083 86.7154 99.8628 86.6354 99.5908 86.5794C99.3188 86.5234 99.0308 86.4954 98.7268 86.4954C98.3588 86.4954 98.0188 86.5194 97.7068 86.5674C97.6828 87.2874 97.6708 87.7914 97.6708 88.0794C97.9588 88.0954 98.1868 88.1034 98.3548 88.1034C98.7148 88.1034 98.9948 88.0954 99.1948 88.0794C99.4028 88.0554 99.6308 88.0194 99.8788 87.9714C99.9108 88.1554 99.9268 88.3314 99.9268 88.4994C99.9268 88.6674 99.9108 88.8474 99.8788 89.0394C98.9348 88.9754 98.2028 88.9474 97.6828 88.9554C97.6828 90.4434 97.7468 91.3554 97.8748 91.6914C97.6108 91.7394 97.3468 91.7634 97.0828 91.7634ZM104.062 91.8474C103.486 91.8474 102.974 91.7194 102.526 91.4634C102.086 91.1994 101.742 90.8354 101.494 90.3714C101.254 89.9074 101.134 89.3714 101.134 88.7634C101.134 88.0834 101.278 87.4794 101.566 86.9514C101.862 86.4234 102.274 86.0114 102.802 85.7154C103.33 85.4194 103.93 85.2714 104.602 85.2714C105.202 85.2714 105.73 85.4034 106.186 85.6674C106.642 85.9314 106.994 86.3034 107.242 86.7834C107.498 87.2554 107.626 87.8034 107.626 88.4274C107.626 89.0914 107.474 89.6834 107.17 90.2034C106.874 90.7154 106.454 91.1194 105.91 91.4154C105.366 91.7034 104.75 91.8474 104.062 91.8474ZM104.338 91.0674C104.898 91.0674 105.342 90.8754 105.67 90.4914C105.998 90.0994 106.162 89.5714 106.162 88.9074C106.162 88.2914 106.014 87.7674 105.718 87.3354C105.43 86.8954 105.038 86.6234 104.542 86.5194C104.174 86.5194 103.842 86.6194 103.546 86.8194C103.25 87.0114 103.018 87.2834 102.85 87.6354C102.682 87.9794 102.598 88.3714 102.598 88.8114C102.598 89.4914 102.758 90.0394 103.078 90.4554C103.398 90.8634 103.818 91.0674 104.338 91.0674ZM109.622 91.7634C109.366 91.7634 109.074 91.7394 108.746 91.6914C108.786 91.2994 108.818 90.7594 108.842 90.0714C108.866 89.3754 108.878 88.7354 108.878 88.1514C108.878 86.7834 108.814 85.9434 108.686 85.6314C108.942 85.5354 109.294 85.4594 109.742 85.4034C110.19 85.3394 110.638 85.3074 111.086 85.3074C111.926 85.3074 112.57 85.4914 113.018 85.8594C113.474 86.2194 113.702 86.7394 113.702 87.4194C113.702 87.8114 113.594 88.1634 113.378 88.4754C113.17 88.7794 112.878 89.0234 112.502 89.2074C113.126 90.4314 113.622 91.1994 113.99 91.5114C113.726 91.6074 113.454 91.6714 113.174 91.7034C112.902 91.7434 112.59 91.7634 112.238 91.7634C112.078 91.3394 111.71 90.5914 111.134 89.5194L110.942 89.5314C110.782 89.5314 110.542 89.5114 110.222 89.4714C110.23 90.5994 110.294 91.3394 110.414 91.6914C110.15 91.7394 109.886 91.7634 109.622 91.7634ZM111.41 88.7634C111.658 88.6354 111.858 88.4634 112.01 88.2474C112.162 88.0314 112.238 87.7874 112.238 87.5154C112.238 86.6674 111.77 86.2434 110.834 86.2434C110.626 86.2434 110.446 86.2634 110.294 86.3034C110.262 86.9114 110.238 87.6474 110.222 88.5114C110.75 88.6794 111.146 88.7634 111.41 88.7634ZM116.95 91.7634C116.718 91.7634 116.434 91.7394 116.098 91.6914C116.138 91.2754 116.17 90.7234 116.194 90.0354C116.218 89.3394 116.23 88.6914 116.23 88.0914C116.23 87.5794 116.214 87.0594 116.182 86.5314C115.198 86.5394 114.586 86.5914 114.346 86.6874C114.306 86.4074 114.286 86.1714 114.286 85.9794C114.286 85.8194 114.306 85.6194 114.346 85.3794C114.674 85.4114 115.114 85.4394 115.666 85.4634C116.226 85.4794 116.754 85.4874 117.25 85.4874C118.442 85.4874 119.178 85.4354 119.458 85.3314C119.498 85.5874 119.518 85.7994 119.518 85.9674C119.518 86.1754 119.498 86.3994 119.458 86.6394C118.994 86.5994 118.386 86.5674 117.634 86.5434C117.594 87.3674 117.574 88.1754 117.574 88.9674C117.574 90.4314 117.638 91.3394 117.766 91.6914C117.55 91.7394 117.278 91.7634 116.95 91.7634Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_308_8028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5464 68.6478C74.4836 68.5743 74.4261 68.4933 74.3558 68.4262C67.7508 62.0907 61.1437 55.7552 54.5366 49.4219C54.4685 49.3569 54.3833 49.309 54.3066 49.2525V49.1673C58.5563 49.1694 62.8059 49.1779 67.0566 49.1641C67.4282 49.163 67.5901 49.2685 67.721 49.6179C70.0008 55.735 72.2965 61.8467 74.5773 67.9628C74.654 68.1684 74.6156 68.4177 74.6316 68.6467H74.5464V68.6478Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5215 68.6478C77.5364 68.4187 77.4991 68.1694 77.5758 67.9638C79.8523 61.8595 82.1427 55.7616 84.4171 49.6562C84.5577 49.2781 84.7408 49.163 85.1412 49.1641C89.1939 49.18 93.2454 49.1737 97.2981 49.1737C97.4482 49.1737 97.5983 49.1737 97.7485 49.1737C97.7847 49.2248 97.8219 49.277 97.8581 49.3281C97.7272 49.407 97.576 49.4645 97.4684 49.5678C90.9295 55.8319 84.3948 62.0992 77.8601 68.3676C77.7696 68.4539 77.6919 68.554 77.6077 68.6467H77.5225L77.5215 68.6478Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3066 45.513C54.7453 44.909 55.1926 44.3113 55.6206 43.7009C57.1635 41.4978 58.7011 39.2904 60.2408 37.0852C60.3292 36.9595 60.4197 36.8349 60.5453 36.6602C62.4077 39.6399 64.2455 42.5812 66.1302 45.5982H54.3066V45.513Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0209 64.5583C74.1064 59.1103 72.1929 53.6622 70.2656 48.1758H81.8848C79.9585 53.6601 78.0419 59.1145 76.1252 64.57L76.0209 64.5594V64.5583Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7559 35.4062H74.4772C72.4892 38.484 70.5279 41.5201 68.5196 44.6288C66.5891 41.5393 64.6863 38.4946 62.7559 35.4062Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6768 35.4062H89.3993C87.473 38.4893 85.5745 41.5287 83.6365 44.6298C81.64 41.5404 79.6787 38.5053 77.6758 35.4062H77.6768Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0391 45.5712C87.9121 42.5734 89.7478 39.6363 91.6122 36.6523C93.6939 39.6352 95.749 42.5787 97.8371 45.5712H86.0391Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1818 45.5837H70.9746C72.6794 42.882 74.3543 40.2272 76.0761 37.5C77.7883 40.2123 79.4653 42.8671 81.1818 45.5837Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3497 28.9212C77.3497 29.7553 77.3539 30.5906 77.3486 31.4247C77.3433 32.2045 76.7981 32.7564 76.057 32.7478C75.3382 32.7393 74.8069 32.1896 74.8048 31.4279C74.7995 29.7585 74.7995 28.0892 74.8048 26.4209C74.8069 25.6411 75.3553 25.0892 76.0964 25.0978C76.8151 25.1063 77.3433 25.656 77.3497 26.4177C77.356 27.2518 77.3507 28.0871 77.3507 28.9212H77.3497Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.496 31.9867C71.5013 32.4831 71.2862 32.8624 70.8603 33.1064C70.4184 33.361 69.9595 33.345 69.5336 33.0776C68.6721 32.5364 67.8235 31.9771 66.9695 31.4242C66.6139 31.1941 66.2518 30.9725 65.9068 30.7275C65.3255 30.3141 65.1743 29.5855 65.532 29.0038C65.8973 28.4115 66.6554 28.2005 67.2719 28.5841C68.5188 29.3596 69.7465 30.1671 70.9742 30.9736C71.3267 31.2058 71.4928 31.5606 71.496 31.9867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8021 29.6511C86.8085 30.1103 86.6274 30.4799 86.2441 30.7303C85.0388 31.5186 83.8355 32.3123 82.6142 33.0772C81.9785 33.4756 81.2065 33.2753 80.836 32.6692C80.4708 32.0726 80.6305 31.3322 81.2502 30.922C82.4279 30.1422 83.6098 29.3677 84.8077 28.6199C85.7096 28.0563 86.7893 28.6295 86.8021 29.6511Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_308_8028",
    x: 17.0918,
    y: 76.4287,
    width: 120.139,
    height: 28.9463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_308_8028"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_308_8028",
    x: 31.5608,
    y: 85.2715,
    width: 91.9573,
    height: 14.5762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_8028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_8028",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_308_8028",
    x: 50.3066,
    y: 24.0977,
    width: 51.5515,
    height: 52.5498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_8028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_8028",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0166667 0 0 0 0 0.0166667 0 0 0 0 0.0166667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_308_8028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_308_8028",
    x1: 104.922,
    y1: 32.9611,
    x2: 153.485,
    y2: 32.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_308_8028",
    x1: 104.922,
    y1: 36.8698,
    x2: 149.452,
    y2: 36.8698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_308_8028",
    x1: 0.460286,
    y1: 45.3484,
    x2: 143.132,
    y2: 45.3484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_308_8028",
    x1: 0.463578,
    y1: 49.2532,
    x2: 139.109,
    y2: 49.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_308_8028",
    x1: 0.463556,
    y1: 57.7317,
    x2: 132.783,
    y2: 57.7317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_308_8028",
    x1: 0.463564,
    y1: 61.6379,
    x2: 128.756,
    y2: 61.6379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_308_8028",
    x1: 0.462891,
    y1: 32.9611,
    x2: 49.0256,
    y2: 32.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_308_8028",
    x1: 4.49219,
    y1: 36.8698,
    x2: 49.028,
    y2: 36.8698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_308_8028",
    x1: 10.8177,
    y1: 45.3484,
    x2: 0.988953,
    y2: 45.3484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_308_8028",
    x1: 14.8438,
    y1: 49.2532,
    x2: 0.98815,
    y2: 49.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_308_8028",
    x1: 21.1641,
    y1: 57.7317,
    x2: 0.988089,
    y2: 57.7317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_308_8028",
    x1: 25.1953,
    y1: 61.6379,
    x2: 0.987286,
    y2: 61.6379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_308_8028",
    x1: 76.9735,
    y1: 95.2938,
    x2: 76.9735,
    y2: 12.8776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40526F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717F8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_308_8028",
    x1: 32.5423,
    y1: 10.5849,
    x2: 76.9735,
    y2: 10.5849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_308_8028",
    x1: 38.1133,
    y1: 15.2662,
    x2: 76.9728,
    y2: 15.2662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_308_8028",
    x1: 54.7592,
    y1: 105.914,
    x2: 54.7592,
    y2: 14.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_308_8028",
    x1: 57.547,
    y1: 100.037,
    x2: 57.547,
    y2: 18.4062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_308_8028",
    x1: 76.9733,
    y1: 10.5849,
    x2: 121.41,
    y2: 10.5849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_308_8028",
    x1: 76.9727,
    y1: 0.551855,
    x2: 115.837,
    y2: 0.551855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_308_8028",
    x1: 99.1908,
    y1: 105.914,
    x2: 99.1908,
    y2: 14.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_308_8028",
    x1: 96.4057,
    y1: 100.037,
    x2: 96.4057,
    y2: 18.4062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_308_8028",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.9716 70.1269) scale(74.682 74.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DFE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C3C9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFB7D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_308_8028",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.7713 54.5286) scale(42.9597 42.9597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA5B2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_308_8028",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.3882 -6.07425) scale(65.7236 66.3875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927793,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_308_8028",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.367 -21.7576) scale(65.4405)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_308_8028",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6605 12.8773) scale(12.3266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5C3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7A90AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#556476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#37404C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1F252B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0E1114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrilliantEffort);
export default __webpack_public_path__ + "static/media/brilliant-effort.886de394434df0477f77df60b7a9438e.svg";
export { ForwardRef as ReactComponent };